import React, { useState, useEffect } from "react";
import RequestAccess from "../components/RequestAccess";

const OfferBanner = () => {
  const [showForm, setShowForm] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Animation keyframes for wiggle effect
  const wiggleAnimation = {
    animation: "wiggle 0.5s ease-in-out infinite",
  };

  return (
    <>
      {/* Wiggle animation keyframes */}
      <style>
        {`
          @keyframes wiggle {
            0% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            50% { transform: translateX(5px); }
            75% { transform: translateX(-5px); }
            100% { transform: translateX(0); }
          }
        `}
      </style>

      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: isMobile ? "center" : "space-between",
          alignItems: "center",
          textAlign: isMobile ? "center" : "left",
          padding: isMobile ? "8px 10px" : "15px 40px",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          boxShadow: "0 -1px 10px rgba(0, 0, 0, 0.15)",
          zIndex: 9999,
          gap: isMobile ? "8px" : "0",
        }}
      >
        {/* Left Side */}
        <div
          style={{
            fontSize: isMobile ? "16px" : "22px",
            fontWeight: "bold",
            color: "#000",
            margin: isMobile ? "0" : "0 0 0 10%",
          }}
        >
          Master ChatGPT & 3000+ Prompts Just ₹199! Limited Time!
        </div>

        {/* Right Side */}
        <div
          style={{
            margin: isMobile ? "0" : "0 10% 0 0",
          }}
        >
          <button
            style={{
              ...wiggleAnimation,
              background: "linear-gradient(to right, #f8b500, #e68a00)",
              padding: isMobile ? "14px 20px" : "14px 32px",
              fontSize: isMobile ? "16px" : "18px",
              fontWeight: "600",
              color: "#1f1f1f",
              border: "none",
              borderRadius: "12px",
              justifyContent:'center',
              textAlign:'center',
              alignItems:'center',
              cursor: "pointer",
              whiteSpace: "nowrap",
              width: isMobile ? "300px" : "300px",
              maxWidth: isMobile ? "250px" : "none",
            }}
            onClick={() => setShowForm(true)}
          >
            Buy & Start Today
          </button>
        </div>
      </div>

      {/* Popup Form */}
      {showForm && <RequestAccess onClose={() => setShowForm(false)} />}
    </>
  );
};

export default OfferBanner;
